// extracted by css-extract-rspack-plugin
export default {"toast":"toast-uuHwDd","icon":"icon-aBSyS0","message":"message-r0tHdq","actions":"actions-mEwAZy","close":"close-OG4uZu"};